export default __webpack_public_path__ + "static/media/grand-hotel.5761fdc6.gif";